import axios from 'axios'
import qs from 'qs'
import Login from './login'
import { getCommonParams, sendRaptorErr } from './util'
import toast from '../components/toast/index'

// 创建一个axios实例，设置基本配置
const Ajax = axios.create({
  baseURL: process.env.VUE_APP_SERVER_URL || 'https://quickpass.meituan.com',
  timeout: 6000,
  method: 'post',
  withCredentials: true,
  headers: {
    'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
  },
})

// 日志和错误发送函数
const logAndSendError = (message, error, type) => {
  console.warn(message, error)
  sendRaptorErr(message, error, type)
}

// 处理请求错误
const handleRequestError = (err) => {
  logAndSendError('请求异常', err, 'ajaxError')
  return Promise.reject(err)
}

// 处理响应错误
const handleResponseError = (response) => {
  logAndSendError('响应异常', response, 'ajaxError')
  toast.show({ type: 'text', text: response.statusText })
  return Promise.reject(response.statusText)
}

// 处理服务器错误
const handleServerError = (response) => {
  logAndSendError('服务端响应异常', response, 'ajaxError')
  const code = response.data.error.code
  const errorHandlers = {
    20001: () => {
      Login()
      return Promise.reject({ code, message: '请重新登录' })
    },
    30001: () => {
      Login()
      return Promise.reject({ code, message: '请重新登录' })
    },
    300110: () => Promise.reject({ code }),
    300301: () => Promise.reject({ code }),
    300302: () => Promise.reject({ code }),
    300104: () => Promise.reject({ code }),
    default: () => Promise.reject(response.data.error),
  }
  return (errorHandlers[code] || errorHandlers.default)()
}

// 请求拦截器
Ajax.interceptors.request.use(
  async (config) => {
    try {
      const commonParams = await getCommonParams()
      if (config.url === '/qrcode/offline/getseed') {
        localStorage.setItem('AESkey', commonParams.AESKey)
      }
      config.data = qs.stringify(Object.assign(commonParams, config.data))
    } catch (e) {
      if (config.url === '/qrcode/offline/getseed') {
        localStorage.setItem('AESkey', e.AESKey)
      }
      config.data = qs.stringify(Object.assign(e, config.data))
    }
    return config
  },
  handleRequestError
)

// 响应拦截器
Ajax.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      return handleResponseError(response)
    }
    if (response.data.status !== 'success') {
      return handleServerError(response)
    }
    return response.data.data
  },
  (err) => {
    if (
      err.message === 'Network Error' ||
      err.message.startsWith('timeout of')
    ) {
      logAndSendError('网络异常/请求超时', err, 'ajaxError')
    } else {
      logAndSendError('未知响应异常', err, 'ajaxError')
    }
    return Promise.reject({ code: 100000, message: '断网环境' })
  }
)

export default Ajax
